import React, { Suspense } from "react"
import "../cssx/icon.css"
import "../cssx/content.css"
import "../cssx/toolbar.css"
import "devextreme/ui/select_box"
import MyToolbar from "./content/myToolbar"
function fileExists(path) {
    try {
        return require("../pages/" + path)
    } catch (err) {
        return null
    }
}
function toProperCase(str) {
    let string = str.toLowerCase().replace(/(?:^|[\s-/_])\w/g, function (match) {
        return match.toUpperCase()
    })
    return string.replace("_", "")
}
class Content extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...props }
        this.state.theme = localStorage.getItem(this.state.app.themeStorageName)
        if (this.state.theme === null) this.state.theme = "carmine"
        this.state.ready = false
    }
    renderItemMain = (e, retry) => {
        if (retry === undefined) retry = false
        try {
            if (e.page === undefined || e.page === null) {
                if (e.id === "") e.id = "dashboard"
                else e.id = e.id.replace(".", "/")
                if (e.id.split("/").length > 1) {
                    e.pageName = toProperCase(e.id.split("/")[1]) + "Page"
                    e.fileName = e.id + `/${e.pageName}`
                    if (fileExists(`${e.fileName}.js`)) {
                        e.page = React.lazy(() =>
                            import("../pages/" + e.fileName).catch((ex) => {
                                e.page = null
                            })
                        )
                    } else {
                        e.page = React.lazy(() =>
                            import("./menuPage/" + e.id).catch((ex) => {
                                e.page = null
                            })
                        )
                    }
                } else {
                    e.page = React.lazy(() =>
                        import("./menuPage/" + e.id).catch((ex) => {
                            e.page = null
                        })
                    )
                }
            }
            // console.log(e.childState)
            return (
                <div className="width-100 height-100 dx-theme-background-color dx-theme-text-color p-1 position-relative">
                    <Suspense fallback={"Page '" + e.name + " / " + e.id + "' not found "}>
                        {e.page === undefined || e.page === null ? (
                            "Page '" + e.name + " / " + e.id + "' not found "
                        ) : (
                            <>
                                <div className="position-absolute w-100 pr-2"><div className="section-title"><h2>{e.name}</h2></div></div>
                                <div className="w-100 h-100 pt-4">
                                    <e.page
                                        info={e}
                                        fn={this.state.fn}
                                        app={this.state.app}
                                        catch={(ex) => console.log(ex)}
                                        default={"what"}
                                        changeChildState={(res) => {
                                            return
                                            if (e.childState !== undefined)
                                                Object.keys(res).forEach((key) => {
                                                    e.childState[key] = res[key]
                                                })
                                            else e.childState = res
                                        }}
                                        childState={e.childState}
                                        onExport={{
                                            start: this.onExporting,
                                            end: this.onExported,
                                            hidden: this.findHiddenColumn
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </Suspense>
                </div>
            )
        } catch (ex) {
            if (!retry) return this.renderItemMain(e, true)
            else
                return (
                    <div className="width-100 height-100 dx-theme-background-color dx-theme-text-color p-1">
                        <div className="mb-2">
                            <span className="border-bottom pb-1">{e.name}</span>
                        </div>
                        Sorry.. There's something when wrong
                    </div>
                )
        }
    }
    findHiddenColumn = (grid, x) => {
        x = {
            hiddenColumn: [],
            filter: grid.option("columns").filter((expr) => {
                if (expr.visible === undefined || expr.visible === null) return false
                else return !expr.visible
            }),
            i: 0
        }
        for (x.i in x.filter)
            if (x.filter[x.i].dataField !== undefined && x.filter[x.i].dataField !== null) x.hiddenColumn.push(x.filter[x.i].dataField)
        return x.hiddenColumn
    }
    onExporting = (grid, x) => {
        grid.beginUpdate()
        x = { hiddenColumn: x, i: 0 }
        for (x.i in x.hiddenColumn) grid.columnOption(x.hiddenColumn[x.i], "visible", true)
    }
    onExported = (grid, x) => {
        x = { hiddenColumn: x, i: 0 }
        for (x.i in x.hiddenColumn) grid.columnOption(x.hiddenColumn[x.i], "visible", false)
        grid.endUpdate()
    }
    render() {
        return (
            <>
                <link rel="stylesheet" type="text/css" href={"css/dx." + this.state.theme + ".css"} onLoad={() => this.setState({ ready: true })} />
                {this.state.ready ? (
                    <MyToolbar fn={this.state.fn} app={this.state.app} updateTheme={this.updateTheme} renderItemMain={this.renderItemMain} />
                ) : (
                    <div className="modal-screen">
                        <div className="loader"></div>
                    </div>
                )}
            </>
        )
    }
    updateTheme = (e) => {
        this.setState({ theme: e })
    }
    renderTheme = () => {
        return <link rel="stylesheet" type="text/css" href={"css/dx." + this.state.theme + ".css"} onLoad={() => this.setState({ ready: true })} />
    }
}
export default Content
